module.exports = __webpack_public_path__ + "assets/images/auth-image-fallback@2x.157fd18ac0730cfcbd9f6724587a229c.webp";